<div class="mb-3">
  @if (appealsService.message == 'SUCCESS_CONTINUANCE') {
  <nh-alert type="success" [isOpen]="appealsService.showMessage">
    @if (appealsService.message == 'SUCCESS_CONTINUANCE') {
    <div class="col message">
      <span>{{ "CONTINUANCE_SUBMITTED" | globalTranslate }}</span>
    </div>
    }
  </nh-alert>
  } @if (appealsService.message == 'ERROR_MESSAGE') {
  <nh-alert type="warning" [isOpen]="appealsService.showMessage">
    @if (appealsService.message == 'ERROR_MESSAGE') {
    <div class="col message">
      <span>{{ "ERROR_CONTINUANCE_SUBMIT" | globalTranslate }}</span>
    </div>
    }
  </nh-alert>
  }
  <div class="bg-custom">
    <div class="container">
      @if (memberInfo) {
      <div>
        <h1 class="section-header textcolor">
          {{ "CONTINUANCE_DETAILS" | globalTranslate }}
        </h1>
        <hr />
        <div>
          <p style="padding-bottom: 10px">
            {{ "APPROVAL_MSG_CONTINUANCE" | globalTranslate }}
          </p>
        </div>
        <div>
          <p class="textcolor">
            <strong>{{
              "APPELLANT_NAME_CONTINUNACE" | globalTranslate
            }}</strong>
            <strong>{{ ": " }}</strong
            >{{ memberInfo.appellantName }}
          </p>
          <p class="textcolor">
            <strong>{{ "APPEAL_NUMBER_CONTINUNACE" | globalTranslate }}</strong>
            <strong>{{ ": " }}</strong
            >{{ memberInfo.appealNumber }}
          </p>
          <p class="textcolor">
            <strong>{{
              "YOUR_CURRENT_HEARING_DATE_CONTINUANCE" | globalTranslate
            }}</strong
            ><strong>{{ ": " }}</strong
            >{{ proposedHearingDate }}
          </p>
          <form [formGroup]="appealContinuanceForm">
            <nh-field
              class="textcolor"
              id="app_con_submittedby"
              [mandatory]="true"
              [attr.aria-required]="true"
              label="{{ 'SUBMITTEDBY_CONTINUANCE' | globalTranslate }}"
            >
              <div>
                <p class="note_padding">
                  {{ "CONT_NOTE_SUBMITTEDBY" | globalTranslate }}
                </p>
              </div>
              <input
                type="text"
                class="form-control"
                name="submittedBy"
                formControlName="submittedBy"
                [attr.aria-label]="'SUBMITTEDBY_CONTINUANCE' | globalTranslate"
                autofocus="true"
                (input)="submittedValidator($event)"
                maxlength="2000"
                required
              />
            </nh-field>
            <p></p>
            <nh-field
              class="textcolor"
              id="app_con_relationship"
              [mandatory]="true"
              [attr.aria-required]="true"
              label="{{ 'REQUEST_RELATIONSHIP_CONTINUANCE' | globalTranslate }}"
            >
              <div>
                <p class="note_padding rel_pad">
                  {{ "CONT_NOTE_RELATIONSHIP" | globalTranslate }}
                </p>
              </div>
              <nh-count>
                <textarea
                  maxlength="2000"
                  class="form-control"
                  name="relationshipWithAppellant"
                  formControlName="relationshipWithAppellant"
                  [attr.aria-label]="
                    'REQUEST_RELATIONSHIP_CONTINUANCE' | globalTranslate
                  "
                  rows="5"
                  autofocus="true"
                  required
                >
                </textarea>
              </nh-count>
            </nh-field>
            <p></p>
            <nh-field
              class="textcolor"
              id="app_con_comments"
              [mandatory]="true"
              [attr.aria-required]="true"
              label="{{ 'REQUEST_COMMENTS_CONTINUANCE' | globalTranslate }}"
            >
              <nh-count>
                <textarea
                  maxlength="2000"
                  class="form-control"
                  name="reasonForContinuance"
                  formControlName="reasonForContinuance"
                  [attr.aria-label]="
                    'REQUEST_COMMENTS_CONTINUANCE' | globalTranslate
                  "
                  rows="5"
                  autofocus="true"
                  required
                >
                </textarea>
              </nh-count>
            </nh-field>
            <div>
              <nh-field
                class="textcolor"
                id="app_con_comments"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="{{ 'Appellant_Signature' | globalTranslate }}"
              ></nh-field>
              <div class="checkbox-label">
                <input
                  type="checkbox"
                  name="appellantSignSW"
                  formControlName="appellantSignSW"
                  checkedValue="E"
                  (change)="deselect($event)"
                  [attr.aria-label]="'Appellant_Signature' | globalTranslate"
                />
                <p
                  style="padding-left: 15px"
                  [innerHTML]="'Continuance_Checkbox' | globalTranslate"
                ></p>
              </div>
              <div>
                <nh-field
                  id="appellantSign"
                  label="{{ 'SIGNATURE' | globalTranslate }}"
                  class="label-section"
                  [mandatory]="true"
                  [attr.aria-required]="true"
                >
                  <input
                    type="text"
                    class="form-control"
                    name="appellantSign"
                    autofocus="true"
                    formControlName="appellantSign"
                    [attr.aria-label]="'SIGNATURE' | globalTranslate"
                    maxlength="93"
                    (input)="signatureValidator($event)"
                    required
                  />
                </nh-field>
              </div>
            </div>
          </form>
          <div class="row my-1">
            <div class="col-md-12">
              <div
                class="row mt-3 text-center py-3"
                style="padding-top: 0.5rem !important"
              >
                <div class="ms-3">
                  <button
                    id="continue"
                    class="btn d-grid btn-secondary btn-width"
                    (click)="
                      onSubmit(
                        this.memberInfo,
                        this.appealContinuanceForm.controls,
                        this.translatedLang
                      )
                    "
                    [disabled]="!isFormValid() || appealsService.showMessage"
                  >
                    {{ "SUBMIT_CONTINUANCE" | globalTranslate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>

  <div class="row my-1">
    <div class="col-md-12" style="margin-top: 7rem !important">
      <div class="row mt-3 text-center py-4">
        <div class="ms-3">
          <button
            id="continue"
            class="btn d-grid btn-secondary btn-width"
            (click)="goToAppealsDashboard()"
          >
            {{ "EXIT" | globalTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>